import React from 'react';
import PropTypes from 'prop-types';
import {withI18n} from 'spa/Components/Context';

import Typography, { TypeVariants } from '@urbanmassage/component-library/lib/Typography/Typography';


const GiftsHeader = ({ currentStep }, {i18n}) => (
  <div className="gifts__header">
    <Typography variant={TypeVariants.labelMMedium} className="gifts__header-subtitle">
      {i18n._x('Step %(step)s of 3', 'Gifts page', {
        step: currentStep,
      })}
    </Typography>
    {currentStep === 1 && (
      <Typography variant={TypeVariants.h1} className="gifts__header-title">
        {i18n._x('Select and personalise', 'Gifts page')}
      </Typography>
    )}
    {currentStep === 2 && (
      <Typography variant={TypeVariants.h1} className="gifts__header-title">
        {i18n._x('Delivery details', 'Gifts page')}
      </Typography>
    )}
    {currentStep === 3 && (
      <Typography variant={TypeVariants.h1} className="gifts__header-title">
        {i18n._x('Review and pay', 'Gifts page')}
      </Typography>
    )}
  </div>
);

GiftsHeader.propTypes = {
  currentStep: PropTypes.number.isRequired,
};

export default withI18n(GiftsHeader);



// WEBPACK FOOTER //
// ./spa/Pages/Gifts/GiftsHeader.jsx